import { Footer } from "@sainsburys-tech/fable";

const Footerfile = () => {
  return (
    <>
      <Footer
        brand="sainsburys"
        colourScheme="grey"
        style={{ margin: "auto", textAlign: "center", width: "100%" }}
        legalText=""
        technicalLinks={
          [
            // {
            //   href: "http://example.com",
            //   text: "Privacy Policy",
            // },
            // {
            //   href: "http://example.com",
            //   text: "Terms & Conditions",
            // },
            // {
            //   href: "http://example.com",
            //   text: "Cookie Policy",
            // },
            // {
            //   href: "http://example.com",
            //   text: "Accessibility",
            // },
            // {
            //   href: "http://example.com",
            //   text: "Sitemap",
            // },
          ]
        }
      />
    </>
  );
};

export default Footerfile;
